











export default {
    name: 'BaseButton',
    components: {},
    props: {
        button_type: String,
        icon_type: String,
    },
    data() {
        return {};
    },
    methods: {},
};
